@if (navBarData(); as data) {
  <div class="scrolling-effect">
    <div class="navigation-route-overview-list">
      @for (item of data.areaList; track item; let i = $index; let last = $last) {
        @if (!item.isHideInNavigation) {
          <div class="route-overview-area">
            <button
              (click)="moveToArea(item.areaId, i)"
              [attr.data-cy]="'navigation-route-area-' + item.areaId + '-group-' + i"
              cue-button
              variant="primary"
              size="small"
              [class.dyed]="item.areaId === areaId() && i === groupIdx()"
              class="big text-transform-none outlined"
              type="button"
            >
              <div class="navigation-levels" #instructionsToScroll [attr.data-groupIdx]="i">
                <div class="main-name">
                  @if (i == 0 && i != data.areaList.length - 1) {
                    <cue-icon [icon]="ICONS.cueStart" />
                  }
                  @if (i == data.areaList.length - 1) {
                    <cue-icon [icon]="ICONS.cueMarker" />
                  }
                  {{ item.name | localizedString }}
                </div>
                <div class="areas">
                  @for (
                    breadcrumb of item.breadcrumbList;
                    track breadcrumb;
                    let first = $first;
                    let lastBreadcrumb = $last;
                    let index = $index
                  ) {
                    @if (!first && !lastBreadcrumb) {
                      <span class="area"
                        >{{ breadcrumb | localizedString }}

                        @if (index < item.breadcrumbList.length - 2) {
                          <cue-icon [icon]="ICONS.cueArrowRight" />
                        }
                      </span>
                    }
                  }
                </div>
              </div>
            </button>

            @if (showNotes() && hasNotes(i)) {
              <div class="route-overview-notes">
                @for (note of notesForArea(i); track note.number) {
                  @if (hasLocalizedValue(note.title) || hasLocalizedValue(note.description)) {
                    <button
                      class="route-overview-note"
                      type="button"
                      (click)="selectRouteOverviewNote(item.areaId, i, note)"
                    >
                      <span class="route-overview-note-number">{{ note.number }}</span>
                      <div>
                        @if (note.title | localizedString) {
                          <h4>{{ note.title | localizedString }}</h4>
                        }
                        @if (note.description | localizedString) {
                          <p>{{ note.description | localizedString }}</p>
                        }
                      </div>
                    </button>
                  }
                }
              </div>
            }
          </div>

          @if (item.enterPortalCategoryName || item.enterPortalCategoryIcon || !last) {
            <div
              class="portal-divider-dots"
              style="--delay: 0.1s"
              [class.following]="item.areaId === areaId() && i === groupIdx()"
            >
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          }

          @if (item.nextItemWillBeHideInNavigation) {
            <button
              class="portal-divider is-active"
              [attr.data-cy]="'navigation-route-hidden-group-' + (i + 1)"
              #instructionsToScroll
              [attr.data-groupIdx]="i + 1"
              (click)="moveToHiddenArea(data, i + 1)"
              type="button"
            >
              @if (item.enterPortalCategoryIcon) {
                <img [src]="item.enterPortalCategoryIcon" alt="" />
              } @else if (!last) {
                <cue-icon [icon]="ICONS.cueCircle" />
              }

              {{ item.enterPortalCategoryName | localizedString }}
            </button>

            @if (showNotes() && hasNotes(i + 1)) {
              <div class="route-overview-notes portal-notes">
                @for (note of notesForArea(i + 1); track note.number) {
                  @if (hasLocalizedValue(note.title) || hasLocalizedValue(note.description)) {
                    <button
                      class="route-overview-note"
                      type="button"
                      (click)="selectHiddenRouteOverviewNote(data, i + 1, note)"
                    >
                      <span class="route-overview-note-number">{{ note.number }}</span>
                      <div>
                        @if (note.title | localizedString) {
                          <h4>{{ note.title | localizedString }}</h4>
                        }
                        @if (note.description | localizedString) {
                          <p>{{ note.description | localizedString }}</p>
                        }
                      </div>
                    </button>
                  }
                }
              </div>
            }
          } @else {
            <span class="portal-divider">
              @if (item.enterPortalCategoryIcon) {
                <img [src]="item.enterPortalCategoryIcon" alt="" />
              } @else if (!last) {
                <cue-icon [icon]="ICONS.cueCircle" />
              }
              {{ item.enterPortalCategoryName | localizedString }}
            </span>
          }

          @if (item.enterPortalCategoryName || item.enterPortalCategoryIcon || !last) {
            <div
              class="portal-divider-dots"
              style="--delay: 1.5s"
              [class.following]="
                (item.nextItemWillBeHideInNavigation && i + 1 === groupIdx()) ||
                (!item.nextItemWillBeHideInNavigation && item.areaId == areaId() && i === groupIdx())
              "
            >
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          }
        }
      }
    </div>
  </div>
}
